/* @flow */
import styled from 'styled-components'
import WMContainer from '@website/common/components/WMContainer'
import Container from '@website/common/components/Container'
import THEME from './Pricing4.theme'

import {
  styleProvider,
  getBackgroundStyles,
  getTextStyleByAlignment
} from '@website/common/utils'
import LibIcon from '@website/common/components/Icon'

const getStyleForProp = styleProvider(THEME)

const StyledContainer = styled(Container)`
  ${getBackgroundStyles(THEME)};
  @media only screen and (min-width: 769px) {
    padding: ${({ isEditing }) => (isEditing ? '150px 0 80px 0' : ' 80px 0')};
  }
`

export const WmCustomContainer = styled(WMContainer)`
  display: flex;
  flex-direction: column;
  .rf-badge-svg {
    position: absolute;
    top: -3px;
    right: -3px;
  }
  > :first-child {
    padding-top: 0;
  }
`

const PricingCardcontent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem 0 20px 0;
`

const PricingCardsContainer = styled.div`
  margin: -20px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  padding-top: 50px;
  @media only screen and (max-width: 992px) {
    padding-top: 40px;
  }
  @media only screen and (max-width: 600px) {
    margin-bottom: 0;
  }
`

const PricingHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  > :last-child {
    margin-bottom: 0;
  }
  .control-container {
    margin-bottom: 20px;
    width: 100%;
    p {
      margin-top: 0;
    }
  }
  > .control-container {
    h1 {
      margin-bottom: 0;
    }
  }
`

const PricingCardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

const PricingCardFooter = styled.div`
  margin-top: auto;
`

const Heading = styled.h1`
  color: ${getStyleForProp('heading')};
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  ${getTextStyleByAlignment};
`

const Paragraph = styled.p`
  width: 100%;
  color: ${getStyleForProp('paragraph')};
  ${getTextStyleByAlignment};
`

const Title = styled.p`
  width: 100%;
  margin: 20px 0 0 0;
  font-weight: bold;
  font-size: 14px;
  ${getTextStyleByAlignment};
  color: ${({ theme }) => theme.palette.tertiaryNormal};
`

const PriceCardWrapper = styled.div`
  display: flex;
  position: relative;
  @media only screen and (min-width: 769px) {
    padding: ${props => (!props.isPrimary ? '20px 0 20px 0' : 'initial')};
  }
  .control-container:not(:first-child) {
    width: 100%;
  }
  .control-container:nth-child(2) {
    margin-top: 20px;
    p {
      margin-top: 0;
    }
  }
  .control-container:nth-child(3) {
    margin-top: 16px;
    margin-bottom: 16px;
    p {
      padding: 0;
    }
  }
`

const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  @media only screen and (min-width: 769px) {
    padding: ${props => (props.isPrimary ? '20px 0 20px 0' : 'initial')};
  }
`

const ButtonWrapper = styled.div`
  margin-top: auto;
  .link {
    border-radius: ${getStyleForProp('buttonRadius')};
    ${props =>
      getStyleForProp(
        props.isPrimary ? 'buttonBackground' : 'buttonBackgroundSecondary'
      )(props)};
    background-repeat: no-repeat;
    text-decoration: none;
    width: 100%;
    max-width: 260px;
    padding: 0 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    text-align: center;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    text-decoration: none !important;
    font-weight: 400;
    background-repeat: no-repeat !important;
    font-size: 14px;
    display: block;
  }
`

const PriceCard = styled.div`
  background-color: white;
  box-sizing: border-box;
  min-width: 280px;
  max-width: 280px;
  width: 280px;
  margin: 20px;
  flex: 1;
  box-shadow: ${props =>
    getStyleForProp(props.isPrimary ? 'raisedShadow' : 'shadow')};
  height: ${props => (props.isEditing ? 'initial' : 'auto')};
  padding: 40px 20px;
  border-radius: ${getStyleForProp('borderRadius')};
  border: ${getStyleForProp('border')};
  display: flex;
  flex-direction: column;
  position: relative;
  @media only screen and (max-width: 600px) {
    margin: 2rem 0 0 0;
  }
`

const Icon = styled(LibIcon).attrs(({ isPrimary, theme }) => ({
  color: isPrimary ? theme.palette.primaryDark : theme.palette.secondaryDark
}))``

const Price = styled.p`
  width: 100%;
  font-size: 54px;
  color: ${({ theme }) => theme.palette.tertiaryDark};
  font-weight: bold;
  padding: 16px 0;
  ${getTextStyleByAlignment};
`

const Option = styled.p`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.tertiaryNormal};
  ${getTextStyleByAlignment};
`

export default {
  Title,
  Heading,
  StyledContainer,
  WmCustomContainer,
  Paragraph,
  PriceCard,
  PricingCardsContainer,
  PricingCardHeader,
  PricingCardFooter,
  PricingHeaderContainer,
  PricingCardcontent,
  Price,
  Option,
  PriceCardWrapper,
  ContentBody,
  ButtonWrapper,
  Icon
}
